import { z } from 'zod'
import { Model } from './architecture'

export const StarsValidation = z.object({
  value: z
    .number({ required_error: '[Stars] value is required' })
    .min(0, { message: '[Stars] value should be bigger than 0' })
    .max(7, { message: '[Stars] value should be smaller than 7' }),
})

export class Stars extends Model {
  static create({ value }: z.infer<typeof StarsValidation>) {
    StarsValidation.parse({ value })
    return new Stars(value)
  }

  constructor(private readonly _value: number) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
